import callingcode from 'callingcodewithdefaultcountry';
import * as Optional from "optional-js";

export function setup() {
    callingcode.init();
}

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
export const mobileRegex = /^\+?[\d\s\-()]+$/;

export class TextField {
    constructor(text, valid, type) {
        this.text = text;
        this.valid = valid;
        this.type = type || "text";
    }

    toString() {
        return this.text;
    }

    set(attr, val) {
        this[attr] = val;
        return this;
    }
}

export class Header extends TextField{
    constructor(text, notEmpty, type) {
        super(text, notEmpty, type);
        this.empty = !notEmpty;
    }
}

export class Email extends TextField{
    constructor(email, valid) {
        super(email, undefined ? false : valid, "email");
    }

    toString() {
        return this.text;
    }
}

/**
 * Factory that generates validated cell numbers
 * @param {string} msisdn
 * @returns Optional.<CellNumber>
 */
export function cellNumberFactory(msisdn) {

    class CellNumber extends TextField{
        constructor(initializer) {
            super(initializer.number, initializer.valid, "mobile");
            this.setInner(initializer);
        }

        setInner(initializer) {
            if (initializer) {
                this.countryCode = initializer.countryCode;
            }
        }

        toString() {
            return this.text;
        }
    }

    const validatedNumber = valMobile(msisdn);

    return validatedNumber ?
        Optional.of(new CellNumber(validatedNumber))
        : Optional.empty();

    function valMobile(supposedNumber) {
        let c;
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(supposedNumber, callingcode.defaultCountryCode);
            const modifiedNumber = callingcode.isPossibleNumber(parsedPhoneNum) ?
                parsedPhoneNum
                : callingcode.parseAndKeepRawInput(supposedNumber.replace(/[\-\s()]+/g, ''), callingcode.defaultCountryCode);
            //here we suppose callingcode.init() has run earlier by the parent view.
            c = callingcode.getRegionCodeForNumber(modifiedNumber);

            const numberType = callingcode.getNumberType(modifiedNumber, c);

            if (numberType === 1 || numberType === 2)
                return {number: callingcode.formatInOriginalFormat(modifiedNumber, c), countryCode: c, valid: true};
        } catch (e) {
            // console.info(`Rejecting possible msisdn value ${supposedNumber}.`, e);
        }
        return {number: supposedNumber, countryCode: null, valid: false};
    }
}